import script from "./up.vue?vue&type=script&setup=true&lang=js"
export * from "./up.vue?vue&type=script&setup=true&lang=js"

import "./up.vue?vue&type=style&index=0&id=255bfc2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255bfc2e"]])

export default __exports__